import React from 'react';

const ArrowIcon = props => {
  return (
    <svg height="8" viewBox="0 0 11 8" width="11" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="m6.71038 0-.71429.666667 3.03572 2.833333h-8.035716v.5.5h8.035716l-3.03572 2.83333.71429.66667 4.28572-4z" />
    </svg>
  );
};

export default ArrowIcon;
